import { motion } from "framer-motion";
import { SectionHeading } from "../site/SectionHeading";

export const STEPS = [
  { num: "01", title: "Apply", text: "Submit an application." },
  { num: "02", title: "Review", text: "MST reviews the applicant for fit, alignment, and eligibility." },
  { num: "03", title: "Invitation", text: "Approved applicants receive an invitation and available membership options." },
  { num: "04", title: "Enter the Network", text: "Approved members enter the private MST platform." },
];

export const HowItWorks = () => (
  <section data-testid="how-it-works-section" className="bg-white py-24 lg:py-32">
    <div className="max-w-7xl mx-auto px-6 lg:px-8">
      <SectionHeading chapter="05" center label="How MST Works" title="Your Path Into MST" />
      <div className="mt-20 relative">
        <div className="hidden lg:block absolute top-7 left-[12%] right-[12%] h-px bg-gradient-to-r from-[#006FD6]/20 via-[#009BFF]/60 to-[#006FD6]/20" />
        <div className="lg:hidden absolute left-7 top-8 bottom-8 w-px bg-gradient-to-b from-[#006FD6]/20 via-[#009BFF]/60 to-[#006FD6]/20" />
        <div className="grid grid-cols-1 lg:grid-cols-4 gap-14 lg:gap-8">
          {STEPS.map((s, i) => (
            <motion.div
              key={s.num}
              data-testid={`step-${s.num}`}
              initial={{ opacity: 0, y: 28 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: i * 0.12, ease: [0.22, 1, 0.36, 1] }}
              className="relative flex lg:flex-col items-start lg:items-center gap-6 lg:gap-0 lg:text-center"
            >
              <div className="relative z-10 w-14 h-14 rounded-full bg-gradient-to-br from-[#006FD6] to-[#009BFF] flex items-center justify-center shadow-[0_6px_20px_rgba(0,111,214,0.4)] shrink-0">
                <span className="text-sm font-extrabold text-white" style={{ fontFamily: "var(--font-heading)" }}>{s.num}</span>
              </div>
              <div className="lg:mt-7">
                <h3 className="text-[15px] font-extrabold uppercase tracking-widest text-[#041525]" style={{ fontFamily: "var(--font-heading)" }}>
                  {s.title}
                </h3>
                <p className="mt-3 text-sm text-[#6B7280] leading-[1.75] lg:max-w-[240px] lg:mx-auto">{s.text}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
      <p className="mt-16 text-center text-xs uppercase tracking-[0.25em] text-[#6B7280]/70" style={{ fontFamily: "var(--font-heading)" }}>
        Approved members enter the private MST platform powered by phpFox
      </p>
    </div>
  </section>
);
